import { FolderDropdown } from '../../../folders/components';
import { Folder } from '../../../folders/models';
import { DocumentListRow, SecureDocument } from '../../models';
import { DocumentDropdown } from './document-dropdown';

type DocumentsListActionsCellProps = {
  row: DocumentListRow;
  currentFolders: Folder[];
  isSearching: boolean;
  onDocumentStatusUpdateStart: (id: string) => void;
  onDocumentStatusUpdateFinish: (id: string) => void;
  onFolderChange: (id: string) => void;
  onFolderTreeChange: () => void;
  onRefetchList: () => void;
  onShareDocument: () => void;
};

export const DocumentsListActionsCell: React.FC<DocumentsListActionsCellProps> =
  ({
    row,
    currentFolders,
    isSearching,
    onDocumentStatusUpdateStart,
    onDocumentStatusUpdateFinish,
    onFolderChange,
    onFolderTreeChange,
    onRefetchList,
    onShareDocument,
  }) => (
    <>
      {row.isFolder ? (
        <FolderDropdown
          selectedFolder={row}
          currentFolders={currentFolders}
          isSubFolder
          onRefetchFolderTree={onFolderTreeChange}
        />
      ) : (
        <DocumentDropdown
          selectedDocument={row as SecureDocument}
          creatorId={row.creator.id}
          parentFolderId={row.parentFolderId}
          documentStatus={row.status}
          showInFolderItem={isSearching}
          onDeleteDocumentSuccess={onRefetchList}
          onMoveDocumentSuccess={onFolderTreeChange}
          onDocumentStatusUpdateStart={onDocumentStatusUpdateStart}
          onDocumentStatusUpdateFinish={onDocumentStatusUpdateFinish}
          onFolderChange={onFolderChange}
          onShareDocument={onShareDocument}
        />
      )}
    </>
  );
